var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104pt",
    height: "94pt",
    viewBox: "0 0 104 94",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "#299a9dff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002B44",
    opacity: 1,
    d: " M 19.34 1.43 C 21.83 0.73 24.42 0.42 27.01 0.45 C 44.32 0.48 61.64 0.42 78.95 0.48 C 88.06 0.70 96.81 6.18 100.96 14.28 C 102.25 16.38 101.23 19.02 99.33 20.33 C 86.73 30.44 74.14 40.55 61.48 50.58 C 56.42 54.95 48.42 54.92 43.21 50.80 C 30.39 40.62 17.63 30.35 4.84 20.13 C 2.98 18.89 2.37 16.32 3.38 14.36 C 6.59 8.07 12.59 3.38 19.34 1.43 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "#56aa9966"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#46adaf",
    opacity: 0.4,
    d: " M 1.43 31.29 C 5.08 30.85 7.42 34.00 10.05 35.98 C 18.51 42.85 27.09 49.57 35.50 56.50 C 38.80 59.53 42.70 61.94 46.94 63.42 C 50.58 63.66 54.26 63.77 57.88 63.30 C 60.70 62.19 63.45 60.81 65.83 58.91 C 77.00 49.72 88.50 40.95 99.62 31.71 C 100.55 31.45 101.50 31.34 102.47 31.38 C 102.66 43.91 102.48 56.44 102.56 68.97 C 103.32 76.98 98.05 84.24 91.87 88.77 C 88.54 90.63 84.95 92.72 81.01 92.56 C 61.02 92.50 41.04 92.61 21.05 92.50 C 14.18 91.20 8.21 86.57 4.48 80.73 C 3.09 78.00 1.30 75.18 1.45 71.99 C 1.45 58.42 1.47 44.86 1.43 31.29 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.bdff12241d903ebd92bc0f08706b226d.svg";
export { ForwardRef as ReactComponent };